import { render, staticRenderFns } from "./PoFazi.vue?vue&type=template&id=7aade0dc&scoped=true"
import script from "./PoFazi.vue?vue&type=script&lang=js"
export * from "./PoFazi.vue?vue&type=script&lang=js"
import style0 from "./PoFazi.vue?vue&type=style&index=0&id=7aade0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aade0dc",
  null
  
)

export default component.exports